import { render } from "./CustomMultiSelectHorseColor.vue?vue&type=template&id=6bdbaab6"
import script from "./CustomMultiSelectHorseColor.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelectHorseColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__